import { IMG_RECEIPT_RELOAD } from '@repo/assets';
import { Icon } from '@successmode-ktp/kui';
import { useState } from 'react';
import styled from 'styled-components';
import LoadingView from '../common/LoadingView';
import { UnrefundedModal } from './Unrefunded.modal';

type Props = {
  refundIndex?: number | string;
  nationality: string;
  dateOfPurchase: string;
  name: string;
  payment: string;
  refund: string;
  imgSrc?: string;
  btnTitle: string;
  onClick: () => void;
  onReload?: () => void;
  isLoading?: boolean;
};

export const ReceiptSummary = ({
  refundIndex,
  nationality,
  dateOfPurchase,
  name,
  payment,
  refund,
  imgSrc,
  btnTitle,
  onClick,
  onReload,
  isLoading,
}: Props) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Wrapper>
      {!refundIndex && (
        <CautionButton type='button' onClick={() => setIsOpen(true)}>
          <Icon.WarningFilled fillColor='#FF2D55' size={16} />
          Not Inspected by Customs
        </CautionButton>
      )}
      <ContentsWrapper>
        <Date>{dateOfPurchase}</Date>
        <Name>{name || '이름 없음'}</Name>
        <DataWrapper>
          <dl>
            <DataTitle>Payment</DataTitle>
            <DataContents>₩ {payment}</DataContents>
            <DataTitle>Amount of Refund</DataTitle>
            <DataContents>₩ {refund}</DataContents>
          </dl>
          {isLoading && (
            <LoadingWrapper>
              <LoadingView />
            </LoadingWrapper>
          )}
          {!isLoading && imgSrc && <Img src={imgSrc} alt='receipt' />}
          {!isLoading && !imgSrc && (
            <button type='button' onClick={onReload}>
              <Img src={IMG_RECEIPT_RELOAD} alt='reload' />
            </button>
          )}
        </DataWrapper>
      </ContentsWrapper>
      <Button type='button' onClick={onClick}>
        {btnTitle}
      </Button>
      <UnrefundedModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        nationality={nationality}
        title={
          nationality === 'KOR'
            ? '세관에서 검사하지 않은 품목'
            : 'Items Not Inspected by Customs'
        }
      />
    </Wrapper>
  );
};

const CautionButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px;
  border-radius: 6px;
  background: #333;
  color: #fff;
  width: fit-content;
  margin-bottom: 8px;
`;

const Wrapper = styled.div`
  width: 100%;
  border: 1px solid #e5e6e8;
  border-radius: 8px;
  background: #fff;
  padding: 20px 24px;
`;

const Date = styled.span`
  color: #030303;
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
  letter-spacing: -0.28px;
`;

const Name = styled.p`
  margin-bottom: 8px;
  color: #030303;
  font-size: 18px;
  font-weight: 600;
  line-height: 150%;
`;

const ContentsWrapper = styled.div`
  margin-bottom: 16px;
`;

const DataWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`;

const DataTitle = styled.dt`
  color: #80848a;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: -0.24px;
`;

const DataContents = styled.dd`
  color: #030303;
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
  letter-spacing: -0.28px;
`;

const Img = styled.img`
  display: block;
  border-radius: 8px;
  border: 1px solid var(--KTP-Color-Mono-10, #e5e6e8);
  width: 140px;
  height: 126px;
`;

const LoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  border: 1px solid var(--KTP-Color-Mono-10, #e5e6e8);
  width: 140px;
  height: 126px;
`;

const Button = styled.button`
  color: var(--KTP-Grayscale-80, var(--KTP-Color-Mono-80, #3a3b3e));
  font-size: 16px;
  font-weight: 600;
  line-height: 150%; /* 24px */
  letter-spacing: -0.32px;
  padding: 12px 24px;
  width: 100%;
  border-radius: 8px;
  border: 1px solid var(--KTP-Color-Mono-65, #5f6165);
  background: var(--KTP-Color-Mono-00, #fff);
  box-shadow: 0 0 12px 0 rgba(107, 101, 132, 0.2);
`;
